/* pa-article.js · mejoras del artículo de la Revista. NADA de esto es necesario para leerlo.

   El artículo es HTML servido: el índice, la respuesta, los datos clave, las fuentes y los
   enlaces están en el documento sin ejecutar nada. Esto añade dos comodidades encima:

     1. Plegar el índice en móvil. Es un <details open>; sin JS se ve abierto en todas las
        pantallas, que es un fallo suave y no una pérdida. Con JS: abierto en escritorio (donde
        el <summary> es solo un rótulo), cerrado en móvil.
     2. Marcar en el índice la sección que se está leyendo (aria-current="true").

   Un solo IntersectionObserver, sin librerías, y se apaga solo si el navegador no lo tiene. */
(function () {
  'use strict';

  var det = document.querySelector('.pa-toc__det');
  var escritorio = window.matchMedia('(min-width: 921px)');

  function ajustarPliegue() {
    if (!det) return;
    // En escritorio el <summary> no se pulsa: tiene que estar abierto siempre.
    if (escritorio.matches) det.setAttribute('open', '');
    else det.removeAttribute('open');
  }
  if (det) {
    ajustarPliegue();
    if (escritorio.addEventListener) escritorio.addEventListener('change', ajustarPliegue);
    else if (escritorio.addListener) escritorio.addListener(ajustarPliegue);
  }

  if (!('IntersectionObserver' in window)) return;
  var enlaces = [].slice.call(document.querySelectorAll('.pa-toc__enlace[href^="#"]'));
  if (!enlaces.length) return;

  var porId = {};
  var destinos = [];
  enlaces.forEach(function (a) {
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var el = document.getElementById(id);
    if (el) { porId[id] = a; destinos.push(el); }
  });
  if (!destinos.length) return;

  // Se marca el último encabezado que ya ha cruzado la franja superior de la pantalla.
  var actual = null;
  function marcar(id) {
    if (id === actual) return;
    actual = id;
    enlaces.forEach(function (a) { a.removeAttribute('aria-current'); });
    if (id && porId[id]) porId[id].setAttribute('aria-current', 'true');
  }
  var obs = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) marcar(e.target.id);
    });
  }, { rootMargin: '-15% 0px -75% 0px' });
  destinos.forEach(function (d) { obs.observe(d); });
})();
